import PageTitle from "../components/PageTitle";
import { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ApiCall from "../common/ApiCall";
import Index from "../view/Blog/Index";
import { useSelector } from "react-redux";
import { getSlugByLang } from "../common/Helper";
import HomeIcon from "../components/Iocns/HomeIcon";


export default function BlogController() {
    const [blogList, setBlogList] = useState([]);
    const [nextPageUrl, setNextPageUrl] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isBlogsLoading, setIsBlogsLoading] = useState(false);
    const perems = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [blogCategoryList, setBlogCategoryList] = useState([]);
    const queryParams = new URLSearchParams(location.search);
    const urlPage = queryParams.get("page");
    const [inputValue, setInputValue] = useState("");
    const [limit, setLimit] = useState(9);
    const [totalItems, setTotalItems] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const user = useSelector((state) => state.user);
    const slugLang = getSlugByLang(user?.language)
    const [breadcrumbList, setBreadcrumbList] = useState([])

    const handleKeyDown = async (event) => {
        if (event.key === "Enter") {
            await getBlogPageList('blogs', inputValue, 1)
        }
    };


    const getBlogPageList = async (type = 'ALL', search = null, page = currentPage) => {

        let data = {}
        data.type = type;
        // data.page = page;
        // data.pageTill = pageTill;
        data.search = search
        data.page = page
        data.limit = limit


        if (type == 'ALL') {
            setIsLoading(true)
        }
        if (type == 'blogs') {
            setIsLoading(true)
        }



        const getList = await ApiCall('post', 'blog-list', data)
        setIsLoading(false)
        setIsBlogsLoading(false)


        if (getList) {

            if (getList?.data?.success) {
                if (type == 'ALL') {
                    setBlogList(getList.data.data)
                    setTotalPages(getList.data.last_page);
                    setTotalItems(getList.data.total)

                    // setNextPageUrl(getList.data.data.blog_list_next_page_url)
                    if (getList?.data?.categories?.length > 0) {
                        setBlogCategoryList(getList?.data?.categories)
                    }

                }
                if (type == 'blogs') {
                    setBlogList(getList.data.data)
                    setTotalPages(getList.data.last_page);
                    setTotalItems(getList.data.total)
                    setCurrentPage(getList.data.current_page)
                    // setBlogList(prevblogs => [...prevblogs, ...getList.data.data.blogList]);
                    // setNextPageUrl(getList.data.data.blog_list_next_page_url)
                }

            } else {
                navigate('/')
            }
        } else {
            navigate('/')
        }
    }


    useEffect(() => {
        setBreadcrumbList([
            {
                name: <HomeIcon />,
                url: "/" + slugLang
            },
            {
                name: "Blog",
            },

        ])
    }, [user?.language]);

    useEffect(() => {
        (async () => {
            if (urlPage) {
                setCurrentPage(Number(urlPage))
            }
            await getBlogPageList('ALL', null, urlPage)
        })();
    }, [urlPage]);

    const onPageChange = async (page) => {
        setCurrentPage(page);
        window.history.replaceState(null, "", ('/' + slugLang) + '/blog' + '?page=' + page);
        await getBlogPageList('blogs', inputValue, page)
    };




    // const onClickLoadMore = async (type, page) => {
    //     await getBlogPageList(type, page, null, inputValue)
    //     window.history.replaceState(null, "", '/blog' + '?page=' + page);
    // }





    return (
        <>
            <PageTitle
                title={'Blogs'}
            />
            <Index
                blogList={blogList}
                nextPageUrl={nextPageUrl}
                isBlogsLoading={isBlogsLoading}
                // onClickLoadMore={onClickLoadMore}
                isLoading={isLoading}
                blogCategoryList={blogCategoryList}
                handleKeyDown={handleKeyDown}
                inputValue={inputValue}
                setInputValue={setInputValue}
                onPageChange={onPageChange}
                totalPages={totalPages}
                totalItems={totalItems}
                currentPage={currentPage}
                slugLang={slugLang}
                breadcrumbList={breadcrumbList}
            />
        </>
    )
}